export function renderAgeRange(product, appSettings, selectedAgeGroups, setSelectedAgeGroups, trans) {
  console.log(product?.settings?.productAgeRanges);

  const container = document.createElement("div");
  container.style.marginTop = "20px";
  container.style.marginBottom = "20px";
  container.className = "row";
  container.style.flexWrap = "wrap";

  (product?.settings?.productAgeRanges ?? []).forEach((prodAgeRange, index) => {
    const column = document.createElement("div");
    column.className =
      product?.rental_type === "daily" && product?.calendar_type && appSettings?.entity_product_catalog_show_availability_calendar
        ? "col-12 col-sm-6 col-md-4"
        : "col-md-4";

    const formGroup = document.createElement("div");
    formGroup.className = "form-group";

    const label = document.createElement("label");
    label.className = "text-bold-600 font-medium-2 fw-bold ms-2 mb-2";
    label.textContent = prodAgeRange?.age_range?.name;

    const inputGroup = document.createElement("div");
    inputGroup.className = "input-group d-flex flex-row";
    inputGroup.id = "quantity-container-age-range";
    inputGroup.style.maxWidth = "380px";

    const minusButton = document.createElement("button");
    minusButton.className = "btn bg-transparent shadow-sm d-flex align-items-center justify-content-center";
    minusButton.style.width = "10px";
    minusButton.style.border = "1px solid #00000025";
    minusButton.innerHTML = '<i class="fa fa-minus text-muted"></i>';
    minusButton.type = "button";

    minusButton.onclick = () => {
      input.value = String(Number(input.value) - 1);
      if (Number(input.value) < prodAgeRange.participants_min) input.value = String(prodAgeRange.participants_min);
      setSelectedAgeGroups({ group: prodAgeRange?.age_range?.uuid, value: input.value });
    };

    const input = document.createElement("input");
    input.type = "number";
    input.step = "0";
    input.className = "text-center form-control touchspinAgeRange";
    input.dataset.min = prodAgeRange.participants_min || 0;
    input.dataset.max = prodAgeRange.participants_max || 999999;
    input.name = `quantity_${prodAgeRange?.age_range?.uuid}`;
    input.min = "0";
    input.value = String(prodAgeRange.participants_min ?? 0);
    input.onchange = (e) => {
      if (Number(input.value) > prodAgeRange.participants_max) input.value = String(prodAgeRange.participants_max);
      if (Number(input.value) < prodAgeRange.participants_min) input.value = String(prodAgeRange.participants_min);
      setSelectedAgeGroups({ group: prodAgeRange?.age_range?.uuid, value: input.value });
    };

    const plusButton = document.createElement("button");
    plusButton.className = "btn bg-transparent shadow-sm d-flex align-items-center justify-content-center";
    plusButton.style.width = "10px";
    plusButton.style.border = "1px solid #00000025";
    plusButton.innerHTML = '<i class="fa fa-plus text-primary"></i>';
    plusButton.type = "button";
    plusButton.onclick = () => {
      input.value = String(Number(input.value ?? 1) + 1);
      if (Number(input.value) > prodAgeRange.participants_max) input.value = String(prodAgeRange.participants_max);
      setSelectedAgeGroups({ group: prodAgeRange?.age_range?.uuid, value: input.value });
    };

    inputGroup.appendChild(minusButton);
    inputGroup.appendChild(input);
    inputGroup.appendChild(plusButton);

    formGroup.appendChild(label);
    formGroup.appendChild(inputGroup);

    column.appendChild(formGroup);
    container.appendChild(column);
  });

  return container;
}
